import React from 'react';
import { Provider } from 'react-redux';
import Helmet from 'react-helmet';
import { ErrorReporting } from 'mm-ui-components';
import { Store } from 'redux';
import { ErrorReporter } from '../errorReporting/errorReporter.type';
import { AppState, AppActions } from '../store/initialStateRegistration';

interface PageProps {
  store: Store<AppState, AppActions>;
  errorProvider: ErrorReporter;
}

export const Page: React.FunctionComponent<PageProps> = ({ store, children, errorProvider }) => {
  const { locale } = store.getState().config;
  return (
    <React.Fragment>
      <Helmet>
        <html lang={locale} />
      </Helmet>
      <Provider store={store}>
        <ErrorReporting.Provider value={errorProvider}>
          {children}
        </ErrorReporting.Provider>
      </Provider>
    </React.Fragment>
  );
};
